
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response, Headers  } from '@angular/http';
import {environment} from '../../environments/environment'
import {PrettyJsonModule} from 'angular2-prettyjson';
import {Observable} from 'rxjs'
import {UserModel,UserActions } from '../core';

import { CustomerModel } from './models/customer-model'

@Injectable()
export class UsersService {
  private domainStr: string;
  private RIABASE_URL: string = environment.baseWebApiUrl + 'api/RIA/';
  customerUserList: any[];
  constructor(private http: Http) {
    this.domainStr = environment.baseWebApiUrl;
   }

  updateUserFlags(userid:string, action:UserActions): Observable<boolean[]>{
    return this.http.get(this.RIABASE_URL + 'SecurityUserFlags?userid='+userid + '&actions=' + action).pipe(
       map(response => { return  response.json()}));
  }
  securityGetUserByUserID(userid:string):Observable<UserModel>{
    return  this.http.post(this.RIABASE_URL + 'SecurityGetUserByUserID', {userId:userid} ).pipe(
    map(response => { return  response.json()}));
  }
  securitySaveUser(user:UserModel,customerId:number|null):Observable<boolean>{
      return  this.http.post(this.RIABASE_URL + 'SecuritySaveUser' , {user,customerId}).pipe(
        map(response => { return  response.json()}));
   }
  securityIsUserNameAvailable(userName:string):Observable<boolean>{
    return  this.http.post(this.RIABASE_URL + 'SecurityIsUserNameAvailable', {userName:userName}).pipe(
    map(response => { return  response.json()}));
   }
   public getCustomerUserList(userName:string,customerId:number|null): Observable<any> {
    let service = 'GetCustomersUserList';
    return this.http
      .get(this.RIABASE_URL + service+'?userlogin='+userName + '&customerId=' + customerId).pipe(
        map((response) => response.json()),
        map(response => {
          this.customerUserList = response;
          return this.customerUserList;
        }));
  }

}
